import React from "react";
import { ButtonHLPure, InstructionsPure, LabelHLPure } from "../../pures";
import "./signature-base-definition.css";

const SignatureBaseDefinition = (props) => {

    let {
        t,
        step,
        onHandleNext,
        onHandleBack
    } = props

    const { next, back } = step;

    return(
        <div className="signatureBaseDefinition-container">
            <div className="signatureBaseDefinition-body">
                <div className="signatureBaseDefinition-text-container">
                    <div className="signatureBaseDefinition-text">
                        <InstructionsPure instructions={[t("signatureBaseDefinition.text")]}/>
                    </div>
                </div>
            </div>
            <div className="signatureBaseDefinition-container-btns">
                <div className="signatureBaseDefinition-btn-secundary">
                    <ButtonHLPure
                        nameBtn={back}
                        primary={false}
                        onClickBtn={onHandleBack}
                    />
                </div>
                <ButtonHLPure
                    nameBtn={next}
                    primary={true}
                    onClickBtn={onHandleNext}
                />
            </div>
        </div>
    )
}

export { SignatureBaseDefinition as default }